module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("Wars begin when you will,")]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("but they do not end when you please.")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('span', {
    staticClass: "ePub-B-1"
  }, [_vm._v("—NICCOLÒ MACHIAVELLI, ")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("FLORENTINE HISTORIES,")]), _c('span', {
    staticClass: "ePub-B-1"
  }, [_vm._v(" BOOK III, CHAPTER 2")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 78
// module chunks = 0